// extracted by mini-css-extract-plugin
export default {"FeedSelect":"FeedSelector_FeedSelect__jKcHK","AddFeedButton":"FeedSelector_AddFeedButton__+zTPr"};